import {
  ApolloClient,
  concat,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client/core';
import type { NormalizedCacheObject } from '@apollo/client/core';

import createAuthMiddleware from './createAuthMiddleware';
import notAuthorisedMiddleware from './notAuthorisedMiddleware';

export type ClientOptions = {
  graphqlEndpoint: string;
};

function createClient(clientOptions: ClientOptions): ApolloClient<NormalizedCacheObject> {
  const cache = new InMemoryCache();
  const httpLink = createHttpLink({
    uri: clientOptions.graphqlEndpoint,
  });
  const authMiddleware = createAuthMiddleware();

  return new ApolloClient({
    cache,
    link: concat(concat(authMiddleware, notAuthorisedMiddleware), httpLink),
  });
}

export default createClient;
